import { render, staticRenderFns } from "./SrModal.vue?vue&type=template&id=bf769710"
import script from "./SrModal.vue?vue&type=script&lang=js"
export * from "./SrModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports